import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState, Flex, Text } from 'onefaceui-react-components';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import { getResourceTo } from 'react/utils/utils';
import { actionCreators as actionsModals } from 'react/api/actions/modals';

import { formatDateTime } from '../../../utils/formatDateTime';
import { PanelDetails, PanelTable, TextLink } from '../styles';

export function RoutePanel({ route, eventId }) {
  const dispatch = useDispatch();
  const goToRoute = () => {
    dispatch(push(`/maps/route/${route.id}/details/event/${eventId}`));
    dispatch(
      actionsModals.closeModal({
        modalKey: 'eventDetails'
      })
    );
  };

  if (!route || !eventId) {
    return <EmptyState />;
  }

  const getRouteInfos = () => {
    if (!route) return [];

    const getStartRouteLine = () => ({
      label: getResourceTo('notificationPanel.start'),
      planned: formatDateTime(route?.plannedStart),
      projected: formatDateTime(route?.projectedStart),
      actual: formatDateTime(route?.actualStart)
    });

    const getDepartOriginLine = () => ({
      label: getResourceTo('notificationPanel.depart'),
      planned: formatDateTime(route?.plannedDeparture),
      projected: formatDateTime(route?.projectedDeparture),
      actual: formatDateTime(route?.actualDeparture)
    });

    const getArriveDestinationLine = () => ({
      label: getResourceTo('notificationPanel.arrive'),
      planned: formatDateTime(route?.plannedArrival),
      projected: formatDateTime(route?.projectedArrival),
      actual: formatDateTime(route?.actualArrival)
    });

    const getCompleteRouteLine = () => ({
      label: getResourceTo('notificationPanel.complete'),
      planned: formatDateTime(route?.plannedComplete),
      projected: formatDateTime(route?.projectedComplete),
      actual: formatDateTime(route?.actualComplete)
    });

    return [
      getStartRouteLine(),
      getDepartOriginLine(),
      getArriveDestinationLine(),
      getCompleteRouteLine()
    ];
  };

  const routeList = getRouteInfos();

  return (
    <>
      <PanelDetails>
        <Flex justifyContent="space-between" alignItems="center">
          <Text size="xs" onClick={goToRoute}>
            {getResourceTo('accounttype.key')}:
            <TextLink size="xs">{route?.key}</TextLink>
          </Text>
          <Text size="xs">
            {getResourceTo('date')}:
            <strong>{formatDateTime(route?.openedWhen)}</strong>
          </Text>
          <Text size="xs">
            {getResourceTo('accounttype.organization')}:
            <strong>{route?.organization?.description}</strong>
          </Text>
        </Flex>
      </PanelDetails>
      <PanelTable>
        <table>
          <thead>
            <tr>
              <th>{getResourceTo('event')}</th>
              <th>{getResourceTo('notificationpanel.planned')}</th>
              <th>{getResourceTo('notificationpanel.projected')}</th>
              <th>{getResourceTo('notificationpanel.actual')}</th>
            </tr>
          </thead>
          <tbody>
            {routeList.map(({ label, planned, projected, actual }) => (
              <tr key={label}>
                <td>{label}</td>
                <td>{planned}</td>
                <td>{projected}</td>
                <td>{actual}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </PanelTable>
    </>
  );
}

RoutePanel.propTypes = {
  route: PropTypes.object,
  eventId: PropTypes.number
};
